export default {_name:'bluetooth.scan',module:'Field',view:'Element/Bluetooth/Scan',options:{key:'bluetoothScan',filter:{},xs:'auto',ms:'auto'}}